import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import { changeLang } from "../../actions/langAction";

// Component
import LayoutOperation from "../../components/layout_operation";
import Dashboard from "../../components/Table_Monitor/Dashboard";

// Contexts
import { AuthContext, authUserContext } from "../../contexts";

//Listener
import FullScreenListener from "../../components/utility/DashboardUIHFullScreenListener";

function BBtecDashboard(props) {
  const { view_mode } = useParams();
  const title = "Ticket monitor";
  const { masterLang, factUpdate, lastDashboardUpdate } = props;
  const authUserValue = useContext(authUserContext);
  const { CompanyId, OperatorId, ProjectId } = authUserValue;
  const configComponent = authUserValue.configuration?.filter(
    (s) => s.configuration.dashboard.component !== null
  )[0]?.configuration.dashboard?.component;

  return (
    <AuthContext>
      <FullScreenListener>
        <LayoutOperation>
          <Dashboard
            title={title}
            lastDashboardUpdate={lastDashboardUpdate}
            configComponent={configComponent}
            CompanyId={CompanyId}
            OperatorId={OperatorId}
            ProjectId={ProjectId}
            masterLang={masterLang}
            factUpdate={factUpdate}
            view_mode={view_mode}
          />
        </LayoutOperation>
      </FullScreenListener>
    </AuthContext>
  );
}

const mapStateToProps = (state) => ({
  lang: state.lang,
  masterLang: state.masterLang.masterLang,
  factUpdate: state.masterLang.factUpdate,
  lastDashboardUpdate: state.metaData.lastDashboardUpdate,
});
const mapDispacthToProps = (dispatch) => ({
  changeLang: (data) => dispatch(changeLang(data)),
});
export default connect(mapStateToProps, mapDispacthToProps)(BBtecDashboard);
